import { HttpApi } from "@effect/platform";
import { AiAgentGroup } from "./ai-agent";
import { AiGuidanceGroup } from "./ai-guidance";
import { AttachmentGroup } from "./attachment";
import { AutomationExecutionGroup } from "./automation-execution";
import { ChatWidgetGroup } from "./chat-widget";
import { ConnectedTeamsCountsGroup } from "./connected-teams-counts";
import { DefaultRuleGroup } from "./default-rule";
import { HealthGroup } from "./health";
import { IntegrationGroup } from "./integration";
import { IntegrationDevToolsGroup } from "./integration-dev-tools";
import { MacroGroup } from "./macro";
import { MeGroup } from "./me";
import { StreamGroup } from "./stream";
import { StreamTestGroup } from "./stream-test";
import { SupportTicketGroup } from "./support-ticket-comment";
import { SupportTicketCountsGroup } from "./support-ticket-counts";
import { SupportTicketRelatedRecordsGroup } from "./support-ticket-related-records";
import { SupportUserScheduleGroup } from "./support-user-schedule";
import { TagGroup } from "./tag";
import { TeamNotificationGroup } from "./team-notification";
import { TextConciergeGroup } from "./text-concierge";
import { TopicGroup } from "./topic";
import { UserGroupGroup } from "./user-group";
import { ViewFolderGroup } from "./view-folder";
import { VoiceGroup } from "./voice";
import { WebhookGroup } from "./webhook";

export class Api extends HttpApi.make("effect-api")
  .add(HealthGroup)
  .add(MeGroup)
  .add(SupportTicketGroup)
  .add(SupportTicketCountsGroup)
  .add(SupportTicketRelatedRecordsGroup)
  .add(ConnectedTeamsCountsGroup)
  .add(IntegrationGroup)
  .add(IntegrationDevToolsGroup)
  .add(WebhookGroup)
  .add(AttachmentGroup)
  .add(TeamNotificationGroup)
  .add(StreamGroup)
  .add(StreamTestGroup)
  .add(AiAgentGroup)
  .add(MacroGroup)
  .add(TagGroup)
  .add(UserGroupGroup)
  .add(ViewFolderGroup)
  .add(ChatWidgetGroup)
  .add(AutomationExecutionGroup)
  .add(VoiceGroup)
  .add(DefaultRuleGroup)
  .add(TextConciergeGroup)
  .add(TopicGroup)
  .add(AiGuidanceGroup)
  .add(SupportUserScheduleGroup) {}
